import React from 'react';

const checkboxEmpty = () => (
    <svg viewBox="0 0 70 70">
        <path d="M7.373,7.373v55.254h55.254V7.373H7.373z M54.77,54.77H15.23V15.23h39.54V54.77z" />
    </svg>
)

export default checkboxEmpty